import React from "react";
import { Link, useLocation } from "react-router-dom";
import { RiDashboardFill } from "react-icons/ri";
import { IoHardwareChip } from "react-icons/io5";
import { FaUsers } from "react-icons/fa";
import { GiWallet } from "react-icons/gi";
import { RiSettings5Fill } from "react-icons/ri";
import { themeColor } from "../../constant/color";

const BottomNav = () => {
  const location = useLocation();

  const navItems = [
    {
      title: "Dashboard",
      icon: (
        <RiDashboardFill
          size={21}
          color={
            location.pathname.includes("/dashboard")
              ? themeColor.white
              : "#6c6c6c"
          }
        />
      ),
      link: "/dashboard/salesagent",
    },
    {
      title: "Sales",
      icon: (
        <IoHardwareChip
          size={21}
          color={
            location.pathname.includes("/revenue")
              ? themeColor.white
              : "#6c6c6c"
          }
        />
      ),
      link: "/salesagent/revenue",
    },
    {
      title: "Customers",
      icon: (
        <FaUsers
          size={21}
          color={
            location.pathname.includes("/customer")
              ? themeColor.white
              : "#6c6c6c"
          }
        />
      ),
      link: "/salesagent/customer",
    },
    {
      title: "Wallet",
      icon: (
        <GiWallet
          size={21}
          color={
            location.pathname.includes("/wallet") ? themeColor.white : "#6c6c6c"
          }
        />
      ),
      link: "/wallet",
    },
    {
      title: "Settings",
      icon: (
        <RiSettings5Fill
          size={21}
          color={
            location.pathname.includes("/settings")
              ? themeColor.white
              : "#6c6c6c"
          }
        />
      ),
      link: "/settings/profile",
    },
  ];

  return (
    <div className="fixed bottom-0 left-0 w-full bg-gray-900 shadow-lg !z-50 lg:hidden">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item, index) => (
          <Link
            key={index}
            to={item.link}
            className="flex flex-col items-center justify-center w-1/5"
          >
            <div className="flex items-center justify-center">{item.icon}</div>
            <div
              className="text-[12px] mt-1"
              style={{
                color: location.pathname.includes(item.link)
                  ? themeColor.white
                  : "#a3a3a3",
              }}
            >
              {item.title}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BottomNav;
